import React, { Component } from 'react';
import { motion } from 'framer-motion';
import placeholder from './images/import_placeholder.png';

class PostImage extends Component {
  render() {
    const { image } = this.props;
    return (
      <div className="post-image">
        <img
          onDoubleClick={this.props.onDblClick}
          src={image}
          alt="posted"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = placeholder;
          }}
        />
        <div onDoubleClick={this.props.onDblClick} className="like-container">
          <motion.div
            animate={
              this.props.animationFlipper
                ? this.props.likeAnimation
                : { scale: [0, 1.29, 1, 1, 0] }
            }
            transition={{ duration: 1 }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="112"
              height="112"
              viewBox="0 0 48 48"
              fill="white"
              stroke="white"
              strokeWidth="5%"
            >
              <path d="M 15 7 C 8.9424416 7 4 11.942442 4 18 C 4 22.096154 7.0876448 25.952899 10.851562 29.908203 C 14.615481 33.863507 19.248379 37.869472 22.939453 41.560547 A 1.50015 1.50015 0 0 0 25.060547 41.560547 C 28.751621 37.869472 33.384518 33.863507 37.148438 29.908203 C 40.912356 25.952899 44 22.096154 44 18 C 44 11.942442 39.057558 7 33 7 C 29.523564 7 26.496821 8.8664883 24 12.037109 C 21.503179 8.8664883 18.476436 7 15 7 z"></path>
            </svg>
          </motion.div>
        </div>
      </div>
    );
  }
}

export default PostImage;
